import { render, staticRenderFns } from "./CatalogVehiclePrice.vue?vue&type=template&id=70165770&"
import script from "./CatalogVehiclePrice.vue?vue&type=script&lang=js&"
export * from "./CatalogVehiclePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports